import create from 'zustand';
import produce from 'immer';

const STUDENT_PROFILE_INITIAL = {
	grades: [],
	courses: [],
	takes: []
};

export const useStudentProfileStore = create(set => ({
	...STUDENT_PROFILE_INITIAL,

	// Handle grade update
	onUpdateGrade: (id, data) => set(produce(state => {
		// Find updated grade
		const grade = state.grades.find(g => g.id === +id);

		// Update grades fields given in data
		Object.entries(data).forEach(([key, value]) => {
			grade[key] = value;
		});
	})),

	// Handle course update
	onUpdateCourse: (id, data) => set(produce(state => {
		// Find updated course
		const course = state.courses.find(g => g.id === +id);

		// Update courses fields given in data
		Object.entries(data).forEach(([key, value]) => {
			course[key] = value;
		});
	})),

	// Handle take update
	onUpdateTake: (id, data) => set(produce(state => {
		// Find updated take
		const take = state.takes.find(g => g.id === +id);

		// Update takes fields given in data
		Object.entries(data).forEach(([key, value]) => {
			take[key] = value;
		});
	})),

	// Initialize given value
	onInit: (name, value) => set(produce(state => {
		if (name === 'grades') {
			const active = value?.find(g => g.state === 'active');
			const rest = value?.filter(g => g.state !== 'active');
			state[name] = [active, ...rest];
		} else {
			state[name] = value;
		}
	})),

	// Reset store to initial state
	onReset: () => set({
		...STUDENT_PROFILE_INITIAL
	})
}));